import { useQuery } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { expenseQueryConfig } from '@webapp/modules/expense/query-configs/expense'

type UseQueryApprovedExpenseItemCountReturn = {
  count: Nullable<number>
  isLoading: boolean
  error: Nullable<RepoError>
}

export const useQueryApprovedExpenseItemCount =
  (): UseQueryApprovedExpenseItemCountReturn => {
    const { data, isLoading, error } = useQuery<number, RepoError>(
      expenseQueryConfig.approvedItemCount()
    )

    return {
      count: data ?? null,
      isLoading,
      error: error ?? null,
    }
  }
